<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Situação:"
    id="selectSituacao"
    placeholder="Selecione a Situação"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectCampanhaSituacao',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [ {value: 1, text: 'PENDENTE'},
        {value: 2, text: 'ENVIANDO'},
        {value: 3, text: 'ENVIADO'},
        {value: 4, text: 'CONCLUÍDO'}],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectCampanhaSituacao.vue